import React from "react";
import { ArrowUpRightIcon } from "lucide-react";
type ActionLinkProps = {
  href: string;
  children: React.ReactNode;
  variant?: "bronze" | "light" | "outline" | "text";
  className?: string;
  ariaLabel?: string;
};
const variants = {
  bronze: "bg-bronze text-cream hover:bg-sand hover:text-ink",
  light: "bg-cream text-ink hover:bg-sand",
  outline: "border border-current text-current hover:bg-ink hover:text-cream",
  text: "border-b border-current px-0 py-2 text-current hover:text-bronze"
};
export function ActionLink({
  href,
  children,
  variant = "bronze",
  className = "",
  ariaLabel
}: ActionLinkProps) {
  return <a href={href} aria-label={ariaLabel} className={`group inline-flex min-h-12 items-center justify-center gap-3 whitespace-nowrap px-5 py-3 text-xs font-bold uppercase tracking-[0.14em] transition-[background-color,color,border-color,transform] duration-200 ease-out active:translate-y-px focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-bronze ${variants[variant]} ${className}`} data-id="element-1" data-mp="hg67v6g9twao">
      <span data-id="element-2" data-mp="3r8mraftylc5a">{children}</span>
      <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden="true" data-id="element-3" data-mp="3r9xvggrbglwx" />
    </a>;
}